import { forwardRef, useMemo, useCallback } from 'react'
import { noop, useMediaQuery, useTheme, ls } from '@iqueue/ui-kit'
import Map, { FullscreenControl, ScaleControl, NavigationControl, GeolocateControl, Layer } from 'react-map-gl'

function GLMap({
  storeKey,
  id,
  onIdle = noop,
  satellite = false,
  onLoad = noop,
  // interactive = true,
  // center,
  // fitPaddings = [0, 0, 0, 0],
  // features: [],
  onGeolocate,
  children,
  ...props
}, ref) {
  // const { [id]: map } = useMap()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const { theme } = useTheme()

  const mapStyle = useMemo(() => {
    if (satellite) {
      return 'mapbox://styles/mapbox/satellite-streets-v12'
    }

    const t = theme === 'auto' ? prefersDarkMode ? 'dark' : 'light' : theme
    return t === 'light' ?
      'mapbox://styles/mapbox/navigation-guidance-day-v4' :
      'mapbox://styles/mapbox/navigation-guidance-night-v4'
  }, [theme, satellite, prefersDarkMode])

  const initialViewState = useMemo(() => {
    const defaultState = {
      latitude: 41.3111519,
      longitude: 69.2797104,
      zoom: 15,
    }

    return storeKey ? (ls(`gl-map-${ storeKey }`) || defaultState) : defaultState
  }, [storeKey])

  const onMapIdle = useCallback((e) => {
    if (storeKey) {
      ls(`gl-map-${ storeKey }`, {
        latitude: e.target.getCenter().lat,
        longitude: e.target.getCenter().lng,
        zoom: e.target.getZoom(),
      })
    }

    onIdle(e)
  }, [onIdle, storeKey])

  return <Map
    ref={ ref }
    id={ id }
    initialViewState={ initialViewState }
    mapStyle={ mapStyle }
    attributionControl={ false }
    onIdle={ onMapIdle }
    onLoad={ onLoad }
    { ...props }
  >
    { children }

    { !!onGeolocate && <GeolocateControl
      position={ 'bottom-right' }
      showAccuracyCircle
      onGeolocate={ onGeolocate }
    /> }

    <FullscreenControl />
    <ScaleControl />

    <NavigationControl
      position="bottom-right"
    />

    <Layer
      id={ '3d-buildings' }
      source={ 'composite' }
      source-layer={ 'building' }
      filter={ ['==', 'extrude', 'true'] }
      type={ 'fill-extrusion' }
      minzoom={ 15 }
      paint={ {
        'fill-extrusion-color': '#aaa',
        'fill-extrusion-height': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          0,
          15.05,
          ['get', 'height']
        ],
        'fill-extrusion-base': [
          'interpolate',
          ['linear'],
          ['zoom'],
          15,
          0,
          15.05,
          ['get', 'min_height']
        ],
        'fill-extrusion-opacity': 0.6
      } }
    />
  </Map>
}

export default forwardRef(GLMap)
